import { clickTracking } from './clickTracking';
import { hotjarTracking } from './hotjarTracking';
import type { EventProps } from './types';

export const attachHandlers = (eventProps: EventProps): void => {
  hotjarTracking(eventProps);
  clickTracking(eventProps);
};
